import React from 'react';
import Button from '../Button';
import { Icon } from '@iconify/react';

export default function Pricing({
  title,
  subTitle,
  price,
  period,
  featureList,
  btnText,
  btnUrl,
  popular,
  headerColor,
  titleBgColor,
  onSubscribeClick,
}) {
  const handleSubscribeClick = (e) => {
    e.preventDefault();
    if (onSubscribeClick) {
      onSubscribeClick({
        title,
        price: `${price}${period}`,
        subTitle
      });
    }
  };
  return (
    <div className="cs_pricing_card cs_style_1 cs_radius_20 overflow-hidden">
      <div 
        className="cs_pricing_card_head cs_white_color"
        style={{ backgroundColor: headerColor || undefined, textAlign: 'center' }}
      >
        <h3 className="cs_white_color cs_fs_24 cs_semibold">
          <span 
            className={titleBgColor ? "" : "cs_accent_bg"}
            style={{ 
              backgroundColor: titleBgColor || undefined,
              background: titleBgColor ? 'linear-gradient(90deg, #4A90E2 0%, #1E3A8A 100%)' : undefined,
              borderRadius: titleBgColor ? '50px' : undefined,
              padding: titleBgColor ? '12px 24px' : undefined,
              display: titleBgColor ? 'inline-block' : undefined,
              boxShadow: titleBgColor ? '0 2px 8px rgba(0, 0, 0, 0.1)' : undefined,
              transition: titleBgColor ? 'all 0.3s ease' : undefined
            }}
          >
            {title}
          </span>
          {popular && (
            <span className="cs_heading_color cs_normal">Popular</span>
          )}
        </h3>
        {subTitle && <p>{subTitle}</p>}
        <h2 className="cs_white_color mb-0 cs_fs_72 cs_semibold">
          {price}
          <span className="cs_fs_24">{period}</span>
        </h2>
      </div>
      <div className="cs_pricing_card_body">
        <ul className="cs_pricing_card_feature cs_fs_20 cs_heading_color">
          {featureList?.map((item, index) => (
            <li key={index}>
              <i>
                <Icon icon="fa6-solid:circle-check" />
              </i>
              {item}
            </li>
          ))}
        </ul>
        <div className="cs_pricing_card_btn">
          <Button 
            btnUrl="#" 
            btnText={btnText} 
            variant="w-100" 
            onClick={handleSubscribeClick}
          />
        </div>
      </div>
    </div>
  );
}
